module.exports = __webpack_public_path__ + "img/vertical_active.e368ae4e.svg";